export const createNumberArray = (n) =>{
    const result = [];
    for (let i = 1; i <= n; i++) {
        result.push(i);
    }
    return result;
}